import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Button from '@atlaskit/button/custom-theme-button';
import LockIcon from '@atlaskit/icon/glyph/lock-filled';
import { N500, R400 } from '@atlaskit/theme/colors';
import withFrameStyleControl from '../utils/withFrameStyleControl';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../messages';
import { Frame } from '../Frame';
import { AKIconWrapper } from '../Icon';
import { IconAndTitleLayout } from '../IconAndTitleLayout';
import { IconStyledButton } from '../styled';
import { HoverCard } from '../../HoverCard';
const FallbackUnauthorizedIcon = /*#__PURE__*/React.createElement(AKIconWrapper, null, /*#__PURE__*/React.createElement(LockIcon, {
  label: "error",
  size: "small",
  primaryColor: `var(--ds-icon-danger, ${R400})`
}));
export class InlineCardUnauthorizedView extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "frameRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "handleConnectAccount", event => {
      const {
        analytics,
        extensionKey,
        onAuthorise
      } = this.props;
      event.preventDefault();
      event.stopPropagation();
      if (onAuthorise) {
        analytics === null || analytics === void 0 ? void 0 : analytics.track.appAccountAuthStarted({
          extensionKey
        });
      }
      return onAuthorise();
    });
    _defineProperty(this, "renderActionButton", () => {
      const {
        onAuthorise,
        context
      } = this.props;
      const ActionButton = withFrameStyleControl(Button, this.frameRef);
      return onAuthorise ? /*#__PURE__*/React.createElement(ActionButton, {
        spacing: "none",
        component: IconStyledButton,
        onClick: this.handleConnectAccount,
        testId: "button-connect-account"
      }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.connect_link_account_card_name, {
        values: {
          context
        }
      }))) : undefined;
    });
  }
  render() {
    const {
      url,
      icon,
      onAuthorise,
      onClick,
      isSelected,
      testId = 'inline-card-unauthorized-view',
      showAuthTooltip = false
    } = this.props;
    const inlineCardUnauthenticatedView = /*#__PURE__*/React.createElement(Frame, {
      testId: testId,
      isSelected: isSelected,
      ref: this.frameRef
    }, /*#__PURE__*/React.createElement(IconAndTitleLayout, {
      icon: icon ? icon : FallbackUnauthorizedIcon,
      title: url,
      link: url,
      onClick: onClick,
      titleColor: `var(--ds-text-subtle, ${N500})`
    }), this.renderActionButton());
    if (onAuthorise && showAuthTooltip) {
      return /*#__PURE__*/React.createElement(HoverCard, {
        url: url,
        id: this.props.id
      }, inlineCardUnauthenticatedView);
    }
    return inlineCardUnauthenticatedView;
  }
}